import React from "react";
import useTicketTypeInfoController from "./useTicketTypeInfo.controller";
import { PlaneTicketReturnIcon } from "@bookingcom/bui-assets-react/streamline";
import { Icon, Link, Stack, Text } from "@bookingcom/bui-react";
import { Trans } from "@bookingcom/lingojs-react";
import { UIFlightData } from "@flights/types";
import useRouteName from "../../../../../../../hooks/useRouteName";
import useProfiler from "../../../../../../../hooks/useProfiler";
import flights_web_condensed_extras_fd_mdot from "../../../../../../../utils/experiments/funnel/flights_web_condensed_extras_fd_mdot";

const useTicketTypeInfo = (flight: UIFlightData) => {
  const {
    header,
    contentDirection,
    contentAlignment,
    contentGap,
    title,
    subtitle,
    supplierTermsLink,
    status,
    isPreSelected
  } = useTicketTypeInfoController(flight);

  const routeName = useRouteName();
  const { isMobile } = useProfiler();
  const condensedFDMobile =
    routeName == "flightdetails" && isMobile() && !!flights_web_condensed_extras_fd_mdot.trackWithDefaultStage();

  if (!isPreSelected) return undefined;

  return {
    header,
    content: (
      <Stack gap={4} direction="row">
        <Icon svg={PlaneTicketReturnIcon} size={condensedFDMobile ? "medium" : "larger"} />

        <Stack.Item shrink={true} grow={true}>
          <Stack direction={contentDirection} alignItems={contentAlignment} grow={true} gap={contentGap}>
            <Stack.Item grow={true}>
              <Stack gap={4}>
                <div>
                  <Text>{title} </Text>
                  <Text>{subtitle}</Text>
                </div>

                {supplierTermsLink && (
                  <div>
                    <Trans
                      tag="flights_ancillary_offer_flexticket_tandc"
                      variables={{
                        start_link: "<0>",
                        end_link: "</0>"
                      }}
                      components={[<Link key={0} href={supplierTermsLink} attributes={{ target: "_blank" }} />]}
                    />
                  </div>
                )}
              </Stack>
            </Stack.Item>

            <Text color="constructive" variant="body_2">
              {status}
            </Text>
          </Stack>
        </Stack.Item>
      </Stack>
    )
  };
};

export default useTicketTypeInfo;
